const seededRandom = (seed) => {
    let h = 0;
    for (let i = 0; i < seed.length; i++){
        h=Math.imul(31,h) +seed.charCodeAt(i) |0;
    }
    return Math.abs(h) /2147483647;
};

export const generateRivalryVotes = (team1, team2, total=200) => {
    const seed = [team1,team2].sort().join("vs");
    const ratio = seededRandom(seed) *0.4 +0.3;
    const team1Percent = Math.round(ratio *100);
    const team2Percent = 100 - team1Percent;
    const team1Votes = Math.round(ratio*total);
    const team2Votes = total - team1Votes;

    return {team1Votes,team2Votes,team1Percent,team2Percent};
};